import { OrganizationBulkBookingResponseData } from "../../models/organizationBulkBookingData";
import { AxiosResponse } from "axios";
import { BaseCrudService } from "../baseCrudService";
import apiRoutes from "../apiRoutes";

/**
 * The organization bulk booking events service.
 */
export class OrganizationBulkBookingService extends BaseCrudService {
  /**
   * Bulk booking events for organization.
   * @param userIds List of user IDs to be booked
   * @param eventIds List of event IDs to be booked
   * @param organizationId ID of organization to be booked for
   * @returns A promise containing the response with any booking failures
   */
  async bulkBookEventsForMembers(
    userIds: string[],
    eventIds: string[],
    organizationId: string
  ): Promise<OrganizationBulkBookingResponseData | false> {
    const data = {
      user_ids: userIds,
      event_ids: eventIds,
      orga_id: organizationId,
    };

    try {
      const response = await this.create<
        typeof data,
        AxiosResponse<OrganizationBulkBookingResponseData>
      >(apiRoutes.organization_bulk_booking, data, undefined, {
        suppressSnackbars: true,
      });
      return response.data;
    } catch (e) {
      return false;
    }
  }
}
